import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
} from "react-router-dom";
import "./App.css";
import Scroll from "./components/Scroll";
import Header from "./layouts/Header";
import Sidebar from "./layouts/Sidebar";
import Dashboard from "./pages/Dashboard";
import { ToastContainer } from "react-toastify";
import Card from "./pages/Card";
import AddCard from "./pages/AddCard";
import Sticker from "./pages/Sticker";
import AddSticker from "./pages/AddSticker";
import Carol from "./pages/Carol";
import AddCarol from "./pages/AddCarol";
import Wishes from "./pages/Wishes";
import AddWishes from "./pages/AddWishes";
import FestivalType from "./pages/FestivalType";
import AddFestivalType from "./pages/AddFestivalType";
import Playlist from "./pages/Playlist";
import AddPlaylist from "./pages/AddPlaylist";
import Login from "./auth/Login";
import RequireAuth from "./components/RequireAuth";
import Footer from "./layouts/Footer";

function AppContent() {
  const navigate = useNavigate();

  useEffect(() => {
    let authData = JSON.parse(localStorage.getItem("authData"));
    if (authData?.token && window.location.pathname === "/") {
      navigate("/dashboard");
    }
  }, [navigate]);

  return (
    <>
      <Scroll />
      <ToastContainer autoClose={2000} />
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Login />} />
        {/* Protected routes */}
        <Route
          path="/*"
          element={
            <RequireAuth>
              <div className="admin-container">
                <Sidebar />
                <div className="main-content">
                  <Header />

                  <div className="content-wrapper">
                    <Routes>
                      <Route path="/dashboard" element={<Dashboard />} />

                      <Route path="/card" element={<Card />} />
                      <Route path="/add-card" element={<AddCard />} />

                      <Route path="/sticker" element={<Sticker />} />
                      <Route path="/add-sticker" element={<AddSticker />} />

                      <Route path="/carol" element={<Carol />} />
                      <Route path="/add-carol" element={<AddCarol />} />

                      <Route path="/wishes" element={<Wishes />} />
                      <Route path="/add-wishes" element={<AddWishes />} />

                      <Route path="/festival-type" element={<FestivalType />} />
                      <Route path="/add-festival-type" element={<AddFestivalType />} />

                      <Route path="/playlists" element={<Playlist />} />
                      <Route path="/add-playlist" element={<AddPlaylist />} />
                    </Routes>
                  </div>

                  <Footer />
                </div>

              </div>
            </RequireAuth>
          }
        />
      </Routes>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;